export enum ScreenSize {
  Mobile = 'mobile',
  Tablet = 'tablet',
}

export const breakpointUpperLimit: { [key in ScreenSize]: number } = {
  [ScreenSize.Mobile]: 400,
  [ScreenSize.Tablet]: 869,
};

const deviceBreakpoints = {
  mobile: `(max-width: ${breakpointUpperLimit[ScreenSize.Mobile]}.99px)`,
  tablet: `(max-width: ${breakpointUpperLimit[ScreenSize.Tablet]}.99px)`,
};

export default deviceBreakpoints;
